// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerticalAlignBottomOutlinedSvg from "@fishx/icons-svg/es/asn/VerticalAlignBottomOutlined";
import FishxIcon from '../components/FishxIcon';

var VerticalAlignBottomOutlined = function VerticalAlignBottomOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerticalAlignBottomOutlinedSvg
  }));
};

VerticalAlignBottomOutlined.displayName = 'VerticalAlignBottomOutlined';
export default React.forwardRef(VerticalAlignBottomOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerticalAlignBottomOutlined.js
// module id = 4357
// module chunks = 0